/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { QueryResult } from './QueryResult';
import {
    QueryResultFromJSON,
    QueryResultFromJSONTyped,
    QueryResultToJSON,
} from './QueryResult';

/**
 * 
 * @export
 * @interface QueryResponse
 */
export interface QueryResponse {
    /**
     * 
     * @type {string}
     * @memberof QueryResponse
     */
    message: string;
    /**
     * 
     * @type {Array<QueryResult>}
     * @memberof QueryResponse
     */
    results: Array<QueryResult>;
}

/**
 * Check if a given object implements the QueryResponse interface.
 */
export function instanceOfQueryResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "message" in value;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function QueryResponseFromJSON(json: any): QueryResponse {
    return QueryResponseFromJSONTyped(json, false);
}

export function QueryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): QueryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': json['message'],
        'results': ((json['results'] as Array<any>).map(QueryResultFromJSON)),
    };
}

export function QueryResponseToJSON(value?: QueryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
        'results': ((value.results as Array<any>).map(QueryResultToJSON)),
    };
}

